// extracted by mini-css-extract-plugin
export default {"link":"Crypto_link__cS-Zc","container":"Crypto_container__ggEyz","name":"Crypto_name__TO6mk","value":"Crypto_value__EvCdv"};